// @flow

import * as React from 'react';

import Carousel from 'app/components/commons/Carousel';
import Responsive from 'app/components/responsive/Responsive';
import Match from 'app/components/challenge/Match';
import Loader from 'app/components/commons/Loader';

type Props = {
  games?: Array<Object>,
  isRacing?: boolean,
  onRef?: () => void,
  scheme: string
};

const defaultProps = {
  isRacing: false
};

class GamesContent extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    games: [],
    onRef: undefined
  };

  render() {
    const { games = [], isRacing, onRef, scheme } = this.props;
    const isLoading = games.length === 0;

    if (isLoading) {
      return <Loader kind="dark" />;
    }

    const matches = games.map(match => (
      <Match
        key={match.id}
        awayScore={match.awayScore}
        awayTeam={match.awayNickname}
        gameName={isRacing ? `LEG ${match.gameOrder}: ${match.name} R${match.number}` : match.name}
        homeScore={match.homeScore}
        homeTeam={match.homeNickname}
        matchType={isRacing ? 'Race' : 'Match'}
        reverseOrder={match.countryCode === 'US'}
        progress={match.progress}
        scheme={scheme}
        startTime={match.startTime}
        statusId={match.statusId}
        venue={match.venue}
      />
    ));

    return (
      <div ref={onRef}>
        <Responsive mobile tabletPortrait={false}>
          {matches}
        </Responsive>
        <Responsive tabletPortrait tabletLandscape={false}>
          <Carousel slidesToShow={2} slidesToScroll={2}>
            {matches}
          </Carousel>
        </Responsive>
        <Responsive tabletLandscape desktop desktopLarge={false}>
          <Carousel slidesToShow={3} slidesToScroll={3}>
            {matches}
          </Carousel>
        </Responsive>
        <Responsive desktopLarge>
          <Carousel slidesToShow={4} slidesToScroll={4}>
            {matches}
          </Carousel>
        </Responsive>
      </div>
    );
  }
}

GamesContent.defaultProps = defaultProps;

export default GamesContent;
